module.exports = __webpack_public_path__ + "img/destination.feaf3185.svg";